import {ElementRef, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AgentCCPService {
    private isCcpInitialized = false;
    private isCcpWidgetVisible = new BehaviorSubject<boolean>(false);
    private currentAgent: any = null;

    private readonly AWS_REGION_FOR_CONNECT_INSTANCE = 'eu-central-1';
    private readonly AWS_CONNECT_CCP_URL = 'https://routemagic-support.my.connect.aws/ccp-v2/';

    constructor() {}

    private getConnectInstance(): any {
        return globalThis.connect;
    }

    isAgentAvailable(): boolean {
        return this.currentAgent !== null;
    }

    initCCP(ccpContainer: ElementRef): void {
        if (this.isCcpInitialized) {
            console.info('Amazon Connect CCP already initialized');
            return;
        }
        const connect = this.getConnectInstance();

        connect.core.initCCP(ccpContainer.nativeElement, {
            ccpUrl: this.AWS_CONNECT_CCP_URL,
            loginPopup: true,
            loginPopupAutoClose: true,
            region: this.AWS_REGION_FOR_CONNECT_INSTANCE
        });

        connect.core.onInitialized(() => {
            console.info('Amazon Connect CCP initialized successfully');
            this.isCcpInitialized = true;

            connect.agent((agent: any) => {
                this.currentAgent = agent;
            });
        });
    }

    showCCPWidget(): void {
        if (this.isCCPWidgetVisible()) {
            console.debug('Amazon Connect CCP widget already visible');
            return;
        }
        this.isCcpWidgetVisible.next(true);
    }

    closeCCPWidget(): void {
        if (!this.isCCPWidgetVisible()) {
            console.debug('Amazon Connect CCP widget already hidden');
            return;
        }
        this.isCcpWidgetVisible.next(false);
    }

    private isCCPWidgetVisible(): boolean {
        return this.isCcpWidgetVisible.value;
    }

    makeOutgoingCall(phoneNumber: string): void {
        if (!this.isCcpInitialized) {
            console.error('Amazon Connect CCP agent not initialized');
            return;
        }
        if (!this.currentAgent) {
            console.error('Amazon Connect CCP agent not available');
            return;
        }
        const endpoint = this.getConnectInstance().Endpoint.byPhoneNumber(phoneNumber);
        this.currentAgent.connect(endpoint, {
            success: () => {
                console.info('Outbound call started successfully');
            },
            failure: (err) => {
                console.error('Error while making outbound call', err);
            }
        });
    }

    getCCPWidgetVisibilitySubject(): BehaviorSubject<boolean> {
        return this.isCcpWidgetVisible;
    }
}
